import React from 'react';
interface TextareaProps extends React.TextareaHTMLAttributes<HTMLTextAreaElement> {
  label?: string;
  error?: string;
}
export function Textarea({
  label,
  error,
  className = '',
  id,
  ...props
}: TextareaProps) {
  const textareaId = id || props.name || Math.random().toString(36).substr(2, 9);
  return <div className="w-full" data-id="element-232">
      {label && <label htmlFor={textareaId} className="block text-sm font-medium text-gray-700 mb-1" data-id="element-233">
          {label}
        </label>}
      <textarea id={textareaId} className={`
          w-full px-4 py-2 rounded-lg border bg-white transition-colors duration-200
          focus:outline-none focus:ring-2 focus:ring-[#1e3a5f] focus:border-transparent
          disabled:bg-gray-100 disabled:text-gray-500
          ${error ? 'border-red-500 focus:ring-red-500' : 'border-gray-300'}
          ${className}
        `} {...props} data-id="element-234" />
      {error && <p className="mt-1 text-sm text-red-600" data-id="element-235">{error}</p>}
    </div>;
}